import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="w-full"
      style={{
        background: 'var(--bg-primary)',
        borderTop: '1px solid var(--border-subtle)',
        padding: '60px 7.6923% 30px'
      }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div
              className="heading-2 mb-2"
              style={{ color: 'var(--brand-primary)' }}
            >
              American Prime LLC
            </div>
            <p className="body-small mb-4" style={{ color: 'var(--text-secondary)' }}>
              AI Automation Services & Business Consulting
            </p>
            <p className="body-small mb-4" style={{ color: 'var(--text-muted)' }}>
              Helping businesses across the United States leverage AI automation for growth and efficiency.
            </p>
            <div className="flex flex-col space-y-3">
              <a
                href="tel:+12035899774"
                className="flex items-center space-x-2 body-small dark-transition hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                <Phone size={16} />
                <span>+1 (203) 589-9774</span>
              </a>
              <a
                href="mailto:info@americanprimellc.com"
                className="flex items-center space-x-2 body-small dark-transition hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                <Mail size={16} />
                <span>info@americanprimellc.com</span>
              </a>
              <div
                className="flex items-center space-x-2 body-small"
                style={{ color: 'var(--text-secondary)' }}
              >
                <MapPin size={16} />
                <span>United States / North America</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <div className="heading-3 mb-4" style={{ color: 'var(--text-primary)' }}>
              Services
            </div>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/services/website-design"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Website Design
                </Link>
              </li>
              <li>
                <Link
                  to="/services/ai-automation"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  AI Automation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/social-media"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Social Media Growth
                </Link>
              </li>
              <li>
                <Link
                  to="/services/lead-generation"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Lead Generation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/branding"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Branding
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <div className="heading-3 mb-4" style={{ color: 'var(--text-primary)' }}>
              Company
            </div>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/case-studies"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Case Studies
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href="https://calendly.com/americanprimeforyou"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Book a Call
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <div className="heading-3 mb-4" style={{ color: 'var(--text-primary)' }}>
              Legal
            </div>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="body-small dark-transition hover:opacity-100 opacity-70"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="pt-8"
          style={{ borderTop: '1px solid var(--border-subtle)' }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="body-small" style={{ color: 'var(--text-muted)' }}>
              © {currentYear} American Prime LLC. All rights reserved.
            </p>
            <p className="body-small" style={{ color: 'var(--text-muted)' }}>
  AI & Automation Solutions for Modern Businesses.
</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
